<template>
  <!-- only show when loading or when there are slides to show -->
  <template v-if="!state.slides || state.slides.length > 0">
    <component :is="(props.variant !== 'new') ? AppIntersectionObserver : 'section'"
               @intersect="onIntersect"
               :options="intersectionOptions"
               class="grid-block-static"
               role="region"
               :aria-label="computedTitle"
      >
      <h2 class="grid-block-static__title">{{ computedTitle }}</h2>

      <AppScrollMarquee :reverse="isOther">
        <span
            class="grid-block-static__label">
          {{ computedTitle }}
        </span>
      </AppScrollMarquee>
      <div class="grid-block-static__skeleton">
        <AppGridSwiper
            v-show="state.slides && state.slides.length !== 0"
            :slides="state.slides"
            :title="computedTitle"
            :variant="props.variant"
            :filters="filters"
        />
        <AppLoadingIndicator
            v-show="!state.slides && props.variant !== 'new'"
            class="grid-block-static__loader"
        />
      </div>
    </component>
  </template>
</template>

<script setup lang="ts">

// static version of the grid block.
import {useGetGridData} from "~/composables/useGetGridData";
import {computed} from "vue";
import {useGridFilters} from "~/composables/useGridFilters";
import {AppIntersectionObserver} from "#components";

const props = defineProps<{
  variant?: 'new' | 'more' | 'other'
}>()

const state = reactive({
  slides: undefined
})

const intersectionOptions = {
  threshold: '0.025'
}

const titleMapping = {
  new: 'Nieuw',
  more: 'Meer',
  other: 'Anders',
}

const isOther = computed(() => {
  return props.variant === 'other'
})

const computedTitle = computed(() => {

  if (!props.variant) {
    return titleMapping.new
  }

  return titleMapping[props.variant]
})

const filters = useGridFilters()
const onIntersect = (data) => {
  if (data.visible && !state.slides) {
    useGetGridData(props.variant || 'new', filters.value).then((response) => {
      state.slides = response.slides.value
    }).catch((e) => {
      console.warn(e)
    })
  }
}

if (props.variant === 'new') {
  const {slides} = await useGetGridData(props.variant || 'new', filters.value)
  state.slides = slides.value
}

</script>

<style scoped lang="postcss">
.grid-block-static {
  @mixin app-block-margins;

  &__title {
    @mixin sr-only;
  }

  &__label {
    padding-right: 3rem;
    font-family: Midnight, sans-serif;
    font-size: 100px;
    text-transform: uppercase;
    line-height: 1;
    color: var(--color-blue-aqua);

    @media (--md) {
      font-size: 120px;
    }

    @media (--lg) {
      font-size: 140px;
    }
  }

  &__skeleton {
    width: 100%;
    overflow: clip;
    position: relative;
    min-height: 640px;
    transition: height 250ms linear;
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
